import { BuildQueryParamsFunction } from './types';

export const buildQueryParams: BuildQueryParamsFunction = (
  baseParams,
  filters,
  sortParams = {}
) => {
  const params = { ...baseParams };

  // Add filter parameters
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params[key] = value;
    }
  });

  // Add sort parameters
  Object.entries(sortParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params[key] = value;
    }
  });

  return params;
};
